import React, { FC } from 'react';
import { graphql, HeadFC, PageProps } from 'gatsby';
import { PageContext } from '../../gatsby-node';

import Home from '../views/Home';
import SEO from '../components/Head';
import Layout from '../components/Layout';

const Page: FC<PageProps<Queries.MoonpayPageQuery, PageContext>> = props => {
  const {
    data,
    pageContext: { locale },
  } = props;

  return (
    <Layout>
      <Home data={data} locale={locale} provider="moonpay" />
    </Layout>
  );
};

export const Head: HeadFC<Queries.MoonpayPageQuery, PageContext> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query MoonpayPage($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/moonpay/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...SeoHeaderHome
        ...SeoWhyHome
        ...SeoGuide
        ...SeoReadytoGetStarted
        ...SeoFooter
      }
    }
  }
`;

export default Page;
